export const LANGUAGE_CODE = {
    ID: "id",
    EN: "en"
}

export const CHATBOT_LINK = {
    WhatsApp: "https://wa.me/6281384464542",
    Telegram: "https://t.me/pixelbrick_bot"
}